/**
 * Created by pzf on 18/9/1.
 *
 */
/* eslint func-names: 1 */
import React from 'react';
import PropTypes from 'prop-types';
import { LocaleReceiver } from 'mkui-fd';
import { Popedit } from 'mkui-ext';
import Panel from './Panel';
import defaultLocale from "../locale-provider/default";


// string | string[] | number | number[] | LabeledValue | LabeledValue[];
function valueType(props, propName, componentName) {
  const basicType = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]);
  if (props.multiple && props[propName] === '') {
    return new Error(
      `Invalid prop \`${propName}\` of type \`string\` supplied to \`${componentName}\`, `
      + 'expected `array` when `multiple`'
    );
  } else {
    const validate = PropTypes.oneOfType([
      PropTypes.arrayOf(basicType),
      basicType,
    ]);
    return validate(...arguments);
  }
}

class Select extends React.Component {
  /** *******************static************************** */

  static  propTypes = {
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    data: PropTypes.oneOfType([
      PropTypes.array, // 支持两种数据赋值方式，直接赋值或lazyLoad
      PropTypes.object,
    ]),
    size: PropTypes.string,
    theme: PropTypes.string,
    value: valueType,
    lazyLoad: PropTypes.bool,
    icon: PropTypes.element,
    api: PropTypes.func, // 异步加载时会用到
    allowClear: PropTypes.bool,
  };

  static defaultProps = {
    placeholder: '',
    onChange: null,
    disabled: false,
    multiple: false,
    data: [],
    lazyLoad: false,
    icon: null,
    api: null,
    allowClear: false,
  };

  renderSelect = (contextLocale)=> {
    const { value, disabled } = this.props;
    let { placeholder } = this.props;
    const emptyValue = value === null || typeof value === 'undefined';
    if(emptyValue && disabled){
      placeholder = contextLocale.none;
    }else{
      placeholder = placeholder ? placeholder : contextLocale.placeholder;
    }
    return (
      <Popedit
        {...this.props}
        placeholder={placeholder}
        inputClassName="mkui-fee-type-input"
      ><Panel/>
      </Popedit>

    );
  }

  render() {
    return (
      <LocaleReceiver componentName="FeeTypeInput" defaultLocale={defaultLocale.FeeTypeInput}>
        {this.renderSelect}
      </LocaleReceiver>

    );
  }
}

export default Select;
